/**
 * Reload-loop guard shared by the route-boundary silent reload (D5) and the
 * reactive recovery signals (D6, chunk-load failure + validation-class
 * GraphQL error). Per-tab `sessionStorage` timestamp: an automatic reload is
 * allowed only if none happened in the last 5 minutes, so a persistent
 * breakage doesn't loop the tab through reload after reload. Callers MUST
 * call `recordAutoReload()` before actually reloading the page.
 */
export const AUTO_RELOAD_STORAGE_KEY = "msys:last-auto-reload";

const GUARD_WINDOW_MS = 5 * 60 * 1000;

export function canAutoReload(now: number = Date.now()): boolean {
  const raw = window.sessionStorage.getItem(AUTO_RELOAD_STORAGE_KEY);
  if (raw === null) return true;

  const last = Number(raw);
  if (!Number.isFinite(last)) return true;

  return now - last >= GUARD_WINDOW_MS;
}

export function recordAutoReload(now: number = Date.now()): void {
  window.sessionStorage.setItem(AUTO_RELOAD_STORAGE_KEY, String(now));
}
